// External dependencies
import React, { Component } from 'react';
import studentRecordService from '../../../../services/StudentRecordService';
import studentInformationService from '../../../../services/StudentInformationService';
import {getUserData} from '../../../../services/API';
import FaDownload from 'react-icons/lib/fa/download';
import Loading from '../../../Global/Loading';
import { connect } from 'react-redux';
import get from 'lodash.get';
import FaRedo from 'react-icons/lib/fa/refresh';
import {getAdminReports} from '../../../../services/adminReports';

// Internal dependencies
import TeacherSelections from '../../../Reports/containers/TeacherSelections';

class ReportExportCard extends Component{
  constructor(props){
    super(props);
    this.state = {
      reports: null,
      loading: true,
      refreshing: false,
      refreshEnabled: false,
    }
    this.requestReport = this.requestReport.bind(this);
    this.loadReports = this.loadReports.bind(this);
    this.storeReports = this.storeReports.bind(this);
  }

  componentDidMount(){
    this.loadReports();
  }

  storeReports(reports){
    if(!reports){
      return;
    }

    this.setState({
      reports: reports,
      loading: false,
      refreshing: false,
      refreshEnabled: false,
    });
  }

  loadReports(){
    this.setState({loading: true, refreshing: true});
    getAdminReports(this.props.entityId, this.props.entityType,this.props.districtId)
    .then((resp) => {
      this.storeReports(resp);
    });
  }

  requestReport(){
    this.setState({loading: true});
    studentRecordService.requestCSVExport(this.props.entityId, this.props.entityType).then((resp) => {
      this.storeReports(resp.data.exportEntityReport);
    });
  }

  getReportRows(){
    if(!this.state.reports || this.state.reports.length <= 0){
      return(<div className="noReports">No Reports Available</div>);
    } else {
      let reportRows = [];
      for(let i = 0; i < this.state.reports.length; i++){
        let report = this.state.reports[i];
        let createdAt = new Date(report.createdAt);
        let even = i%2 == 0;
        let rowClass = even ? "reportRow" : "reportRow even";
        let completed = report.status.includes("http");
        let window = report.window;

        // get status component. loading if we are refreshing and this report is currently in processing state, a link if the report is complete,
        // and the given status otherwise
        let status = (<div className="status">{report.status}</div>)
        if(completed){
          status = (<a href={report.status} className="downloadButton"><FaDownload className="downloadIcon" size="20" />Download Report</a>);
        } else {
          if(this.state.refreshing){
            status = (<div className="status"><Loading/></div>)
          }
        }
        reportRows.push(
          <div className={rowClass} key={"reportRow" + i}>
            <div className="date">{window + ": " +createdAt.toLocaleString()}</div>
            {status}
          </div>
        );
      }

      return reportRows;
    }
  }

  render(){
    if(!this.state.reports){
      return null;
    }

    let requestEnabled = !this.state.loading && (
                            !this.state.reports[0] ||
                            (this.state.reports[0] && new Date () - new Date(this.state.reports[0].createdAt * 1000) > 600000)
                          );

    return(
      <div className="reportExportCard">
        <div className="cardTitle">
          {this.props.entityType == "district" ? "District" : "School"} Level Report for {this.props.entityName}
          {this.state.refreshEnabled && <FaRedo className="refreshIcon" size="20" onClick={this.loadReports}/>}
        </div>
        {this.getReportRows()}
      </div>
    );
  }
}



class SchoolResults extends Component {
  constructor (props){
    super(props);
    this.state = {
      district: {
        id: null,
        name: null,
      },
      school: {
        id: null,
        name: null,
      },
      isDistrictAdmin: false,
    };
  }

  componentDidMount(){
    let userData = getUserData();
    let isDistrictAdmin = (userData.userType === "DISTRICT_ADMIN" && !userData.subdistrictId && !userData.reportingRole) ||
                          (userData.reportingRole && userData.reportingRole.scopes && userData.reportingRole.scopes.schools && userData.reportingRole.scopes.schools.length === 1 && userData.reportingRole.scopes.schools[0] === "*");
    if(isDistrictAdmin && userData.district){
      this.setState({
        district: {
          id: userData.district.id,
          name: userData.district.label,
        },
        isDistrictAdmin: true,
      });
    } else {
      if(userData.schools && userData.schools[0]){
        this.setState({
          school: {
            id: userData.schools[0].id,
            name: userData.schools[0].label,
          },
          district: {
            id: userData.district.id,
            name: userData.district.label,
          },
          isDistrictAdmin: false,
        });
      }
    }
  }

  render () {
    let selectionProps = {
      isAggregateReport: true,
      hasScoreScaling: false,
      isSchoolReport: true,
      pageTitle: "School Results",
    };

    let selectedSchool = this.props.selectedSchool || this.state.school;

    return (
      <div className="reports-root-container">
        <div className="reports-page-wrap">
          <div className='reports-page'>
            {this.state.isDistrictAdmin && <TeacherSelections
              teacherSelectionTypes={selectionProps}
              selectedMetric={this.props.selectedMetric}
              selectedScale={this.props.selectedScale}
              selectedBenchmark={this.props.selectedBenchmark}
              selectedSchool={this.props.selectedSchool}
              history={this.props.history}
              isAdminReport={true}
            />}
            <div className="SchoolResults">
              {this.state.district && this.state.district.id && this.state.isDistrictAdmin &&
                <ReportExportCard
                  entityId={this.state.district.id}
                  entityType={"district"}
                  entityName={this.state.district.name}
                  districtId={this.state.district.id}
                />
              }
              {(selectedSchool && selectedSchool.id) &&
                <ReportExportCard
                  entityId={selectedSchool.id}
                  entityType={"school"}
                  entityName={selectedSchool.name || selectedSchool.label}
                  districtId={this.state.district.id}
                  key={"schoolReportCard" + selectedSchool.id}
                />
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
 return {
   selectedSchool: get(state, 'reports.roster.ui.selections.school', null),
 }
}

export default connect(mapStateToProps)(SchoolResults);
